var _global = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

_global.SENTRY_RELEASE = {
  id: "dd4f385e8ca874b3fd11dde1b0e6a6d8b276157a"
};